<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 48 48"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M22.962 32.25H40a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H22.962V35a2 2 0 0 1-2 2h-3.077a2 2 0 0 1-2-2v-.25H9a1 1 0 0 1-1-1v-.5a1 1 0 0 1 1-1h6.885V32a2 2 0 0 1 2-2h3.077a2 2 0 0 1 2 2v.25zm11.423-10H40a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1h-5.615V25a2 2 0 0 1-2 2h-3.077a2 2 0 0 1-2-2v-.25H9a1 1 0 0 1-1-1v-.5a1 1 0 0 1 1-1h18.308V22a2 2 0 0 1 2-2h3.077a2 2 0 0 1 2 2v.25zm-13.962-10H40a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H20.423V15a2 2 0 0 1-2 2h-3.077a2 2 0 0 1-2-2v-.25H9a1 1 0 0 1-1-1v-.5a1 1 0 0 1 1-1h4.346V12a2 2 0 0 1 2-2h3.077a2 2 0 0 1 2 2v.25zM15.346 12v3h3.077v-3h-3.077zm13.962 10v3h3.077v-3h-3.077zM17.885 32v3h3.077v-3h-3.077z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
